export default (count) => {
    let thousands = count / 1000

    if (thousands >= 1000) {
        let millions = thousands / 1000

        let decimal = millions.toFixed(1)
        let whole = Math.floor(decimal)

        return ((decimal - whole) == 0) ? whole + "M" : decimal + "M"
    }

    if (thousands >= 1) {
        let decimal = thousands.toFixed(1)
        let whole = Math.floor(decimal)

        return ((decimal - whole) == 0) ? whole + "K" : decimal + "K"
    }

    return count
}
